var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.261088 14.466L6.71859 7.99845L0.261088 1.54095C-0.0819663 1.1979 -0.0819663 0.622777 0.261088 0.269632C0.604143 -0.0936024 1.18935 -0.0835126 1.5425 0.269632L8 6.72713L14.4575 0.269632C14.8006 -0.0835126 15.3757 -0.0835126 15.7389 0.269632C16.0921 0.612687 16.082 1.1979 15.7389 1.54095L9.27132 7.99845L15.7389 14.466C16.082 14.8091 16.082 15.3842 15.7389 15.7374C15.3858 16.0905 14.8006 16.0804 14.4575 15.7374L8 9.27986L1.5425 15.7374C1.18935 16.0804 0.614233 16.0804 0.261088 15.7374C-0.0920561 15.3943 -0.0819663 14.8091 0.261088 14.466Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.32d5f033b3f709dda8e74ac93ebe6571.svg";
export { ForwardRef as ReactComponent };